import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect, useHistory } from 'react-router-dom';
import { DeclarativeModal, FunctionalLoader } from 'seagull';
import { routes } from '~/constants';
import { useRelationship } from '~/hooks/reactQuery/queries/useRelationship';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { relationshipModel } from '~/models';
import EditAgreementModal from './EditAgreementModal';
const editAgreementRoutePrefix = routes.editAgreement().split(':')[0];
export const EditAgreementPage = (param)=>{
    let { match } = param;
    const { relationshipId } = match.params;
    const history = useHistory();
    const { relationship, isLoading, refresh, error } = useRelationship(relationshipId, {
        refreshOnMount: true
    });
    const { AD_HOC_INVOICING: adHocFF } = useFeatureFlags();
    const isEditable = relationship != null && !relationshipModel.isTerminated(relationship) && (relationshipModel.isApproved(relationship) || adHocFF && relationshipModel.isAdHoc(relationship));
    if (isLoading) return /*#__PURE__*/ _jsx(FunctionalLoader, {
        show: true
    });
    if (error != null || relationship == null || !isEditable) return /*#__PURE__*/ _jsx(Redirect, {
        to: routes.home
    });
    const goBack = ()=>{
        if (!history.location.pathname.startsWith(editAgreementRoutePrefix)) return;
        if (history.length > 1) history.goBack();
        else history.push(routes.agreementMinisiteRoutes(relationshipId).agreement);
    };
    return /*#__PURE__*/ _jsx(DeclarativeModal, {
        biName: "edit_agreement_modal",
        isOpen: true,
        treatAsPage: true,
        onClose: goBack,
        content: (modalProps)=>/*#__PURE__*/ _jsx(EditAgreementModal, _object_spread({
                relationship: relationship,
                onUpdate: refresh
            }, modalProps))
    });
};
